<template>
  <a-modal
    :maskClosable="false"
    forceRender
    v-model:visible="payVisible"
    :title="modalTitle"
    @ok="() => {}"
    @cancel="() => changeVisible(false)"
  >
    <a-form
      :model="formState"
      ref="formRef"
      name="basic"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
      autocomplete="off"
    >
      <a-form-item
        label="是否启用"
        name="enable"
        :rules="[{ required: true, message: '请选择启用状态' }]"
      >
        <a-radio-group v-model:value="formState.enable">
          <a-radio :value="0">禁用</a-radio>
          <a-radio :value="1">启用</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        label="国家/省州"
        name="areaCodes"
        :rules="[{ required: true, message: '请选择省州/国家' }]"
      >
        <a-tree-select
          class="w300"
          v-model:value="formState.areaCodes"
          style=""
          :maxTagCount="10"
          :tree-data="modalAreaList"
          tree-checkable
          allow-clear
          :fieldNames="{
            label: 'nameEn',
            value: 'key'
          }"
          search-placeholder="请选择"
        />
      </a-form-item>

      <a-form-item label="主题" :wrapper-col="{ offset: 0, span: 16 }">
        <div
          v-for="(i, index) in formState.themeTypeSort"
          :key="i"
          style="margin-bottom: 10px;"
        >
          <a-card style="width: 200px" size="small">
            <div
              style="display: flex; align-items: center;justify-content: space-between;"
            >
              <p>{{ i }}</p>
              <div>
                <a-button
                  type="link"
                  size="small"
                  v-if="index !== 0"
                  @click="moveThemeSort(index, index - 1)"
                  ><arrow-up-outlined
                /></a-button>
                <a-button
                  type="link"
                  size="small"
                  v-if="index !== formState.themeTypeSort.length - 1"
                  @click="moveThemeSort(index, index + 1)"
                >
                  <arrow-down-outlined />
                </a-button>
              </div>
            </div>
          </a-card>
        </div>
      </a-form-item>
    </a-form>
    <template #footer>
      <div>
        <a-button type="default" @click="() => changeVisible(false)"
          >取消</a-button
        >
        <a-button type="primary" @click="save">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>
<script>
import { inject, toRefs } from 'vue'
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons-vue'
export default {
  components: { ArrowUpOutlined, ArrowDownOutlined },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.ellipsis {
  width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sidebarContentBg .hover {
  width: 120px;
  height: 120px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}
</style>
<style>
.uploadImg .ant-upload.ant-upload-btn {
  padding: 0 !important;
}
</style>
